import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=3ce44568&"
import script from "./ModelForm.vue?vue&type=script&lang=ts&"
export * from "./ModelForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports